import { get } from 'lodash';
import { Profile } from './profile';
import { Orders } from './orders';
import { Order } from './order';
import { Accounts } from './accounts';
import { ChangeEmail } from '../authentication';
import { Routes as RoutesComponent } from './routes';
import { Route } from './route';
import { Schedule } from './schedule';
import { DriveSchedule } from './drive-schedule';
import { ChangePassword } from './change-password';
import { Reconciliation } from './reconciliation';
import { Invite } from './invite';
import { Reports } from './reports';
import { UserReports } from './user-reports';
import { Checkin } from './checkin';
import { LNUpdate } from './lnupdate';
import { FAQ } from './faq';
import { ScheduleSearch } from './schedule-search';
import { FleetManager } from './fleet-manager';
import { DeleteAccount } from './delete-account';
import { ManifestDownload } from './manifest-download';
import { ReconList } from './recon-list';
import { OperationsLog } from './operations-log';
import { BlackoutDates } from './blackout-dates';
import { getConfig, userHasRole } from '../actions/utils';
import { EditConfig } from './editconfig';
import { CustomerDashboard } from './customer-dashboard';
import { Landing } from './landing';
import { AdminDashboard } from './admin-dashboard/admin-dashboard.component';

export const SideRoutes = [
  {
    title: 'Dashboard',
    icon: { type: 'dashboard' },
    path: '/dashboard',
    restrictRoles: [2],
    show: s => !getConfig('hideRoutes', []).includes('shipping')
  },
  {
    title: 'Profile',
    icon: { type: 'user' },
    path: '/dashboard/profile',
  },
  // {
  //   title: 'Schedule',
  //   icon: { lib: 'fontawesome', type: 'calendar-alt' },
  //   path: '/dashboard/schedule',
  // },
  {
    title: 'Invite Users',
    icon: { type: 'usergroup-add' },
    path: '/dashboard/invite',
    allowedRoles: [0, 1, 3],
  },
  {
    title: 'Outgoing Orders',
    icon: { type: 'menu-unfold' },
    path: '/dashboard/orders',
    restrictRoles: [2],
  },
  {
    title: 'Incoming Orders',
    icon: { type: 'menu-fold' },
    path: '/dashboard/incomingorders',
    restrictRoles: [2],
    show: s => !getConfig('hideRoutes', []).includes('incomingorders')
  },
  {
    title: 'Placed Orders',
    icon: { type: 'menu-fold' },
    path: '/dashboard/placedorders',
    allowedRoles: [0, 1, 3],
    show: s => !getConfig('hideRoutes', []).includes('placedorders')
  },
  {
    title: 'New Order',
    icon: { type: 'plus' },
    path: '/dashboard/createOrder',
    restrictRoles: [2],
  },
  // {
  //   title: 'Schedules',
  //   icon: { lib: 'fontawesome', type: 'calendar-alt' },
  //   path: '/dashboard/schedule',
  //   allowedRoles: [0, 1],
  // },
  {
    title: 'Schedules',
    icon: { lib: 'fontawesome', type: 'calendar-alt' },
    path: '/dashboard/manageSchedule',
    allowedRoles: [0, 1, 2],
  },
  {
    title: 'Reconciliations',
    icon: { lib: 'fontawesome', type: 'money-check-alt' },
    path: '/dashboard/reconlist',
    restrictRoles: [2],
    show: s => !getConfig('hideRoutes', []).includes('reconciliations')
  },
  {
    title: 'Delivery Schedule',
    icon: { type: 'file-search' },
    path: '/dashboard/schedulesearch',
    restrictRoles: [2],
  },
  {
    title: 'Driver Schedule',
    icon: { lib: 'fontawesome', type: 'car' },
    path: '/dashboard/manageDriver',
    allowedRoles: [0, 1, 2],
  },
  {
    title: 'Fleet Manager',
    icon: { type: 'car' },
    path: '/dashboard/fleetmanager',
    allowedRoles: [0, 1, 2],
  },
  // {
  //   title: 'Reports',
  //   icon: { type: 'table' },
  //   path: '/dashboard/userreports',
  // },
  {
    title: 'Check Out',
    icon: { type: 'login' },
    path: '/dashboard/checkout',
    restrictRoles: [2],
  },
  {
    title: 'Check In',
    icon: { type: 'login' },
    path: '/dashboard/checkin',
    allowedRoles: [2],
    show: s => !!getConfig('checkin.driverEnabled', false)
  },
  {
    title: 'Manifest Download',
    icon: { type: 'download' },
    path: '/dashboard/manifestdownload',
    restrictRoles: [2],
    show: s => !getConfig('hideRoutes', []).includes('manifestdownload')
  },
  {
    title: 'FAQ',
    icon: { type: 'question-circle' },
    path: '/dashboard/faq',
    restrictRoles: [2],
  },
];

export const AdminSideRoutes = [
  {
    title: 'Dashboard',
    icon: { type: 'dashboard' },
    path: '/dashboard/admin',
    restrictRoles: [2],
    show: s => !getConfig('hideRoutes', []).includes('admin')
  },
  {
    title: 'All Accounts',
    icon: { type: 'user' },
    path: '/dashboard/accounts',
    restrictRoles: [2],
  },
  {
    title: 'All Orders',
    icon: { type: 'unordered-list' },
    path: '/dashboard/adminManageOrders',
    restrictRoles: [2],
  },
  {
    title: 'All Routes',
    icon: { lib: 'fontawesome', type: 'directions' },
    path: '/dashboard/manageRoutes',
    restrictRoles: [2],
  },
  {
    title: 'New Order',
    icon: { type: 'plus' },
    path: '/dashboard/createAdminOrder',
    restrictRoles: [2],
  },
  {
    title: 'Schedules',
    icon: { lib: 'fontawesome', type: 'calendar-alt' },
    path: '/dashboard/adminSchedule',
    restrictRoles: [2],
  },
  {
    title: 'Driver Schedule',
    icon: { lib: 'fontawesome', type: 'car' },
    path: '/dashboard/manageDriver',
  },
  {
    title: 'Operations Log',
    icon: { lib: 'fontawesome', type: 'clipboard-list' },
    path: '/dashboard/operationslog',
    restrictRoles: [2],
    show: s => !getConfig('hideRoutes', []).includes('operationslog')
  },
  {
    title: 'Billing',
    icon: { lib: 'fontawesome', type: 'money-check-alt' },
    path: '/dashboard/billing',
    restrictRoles: [2],
    show: s => !getConfig('hideRoutes', []).includes('billing')
  },
  {
    title: 'Reconciliations',
    icon: { lib: 'fontawesome', type: 'money-check-alt' },
    path: '/dashboard/reconlistadmin',
    restrictRoles: [2],
    show: s => !getConfig('hideRoutes', []).includes('reconciliations')
  },
  {
    title: 'Reports',
    icon: { type: 'table' },
    path: '/dashboard/reports',
    restrictRoles: [2],
  },
  {
    title: 'Check In',
    icon: { type: 'login' },
    path: '/dashboard/checkin',
    restrictRoles: [2],
  },
  {
    title: 'LN Update',
    icon: { type: 'edit' },
    path: '/dashboard/lnupdate',
    restrictRoles: [2],
  },
  {
    title: 'Fleet Manager',
    icon: { type: 'car' },
    path: '/dashboard/fleetmanager',
    restrictRoles: [2],
  },
  {
    // Card #254 — Holiday & Blackout Dates. allowedRoles [0, 1] because the card
    // asks for an "Admin" page; Edit Settings below is superadmin-only, which is
    // why the blackout calendar is not a setting.
    //
    // Round 3: shortened from 'Holiday & Blackout Dates', which overflowed the
    // 200px sider's ~143px text column and was hard-clipped. The page's own <h2>
    // keeps the longer, more descriptive name.
    title: 'Blackout Dates',
    icon: { lib: 'fontawesome', type: 'calendar-times' },
    path: '/dashboard/blackoutdates',
    allowedRoles: [0, 1],
    show: s => !getConfig('hideRoutes', []).includes('blackoutdates'),
  },
  {
    title: 'Edit Settings',
    icon: { type: 'edit' },
    path: '/dashboard/settings',
    allowedRoles: [0],
  },
];

export const Routes = {
  account: {
    title: 'Account',
    icon: { type: 'user' },
    path: '/dashboard/profile',
    highlighted: '/dashboard/profile',
    component: Profile,
    sideRoutes: SideRoutes,
  },
  accounts: {
    title: 'Accounts',
    icon: { type: 'user' },
    path: '/dashboard/accounts',
    highlighted: '/dashboard/accounts',
    component: Accounts,
    sideRoutes: AdminSideRoutes,
  },
  invite: {
    title: 'Invite',
    icon: { type: 'usergroup-add' },
    path: '/dashboard/invite',
    highlighted: '/dashboard/invite',
    component: Invite,
    sideRoutes: SideRoutes,
  },
  accountDetails: {
    title: 'Account',
    icon: { type: 'user' },
    path: '/dashboard/accountDetails',
    component: Profile,
    sideRoutes: SideRoutes,
  },
  landing: {
    title: 'Dashboard',
    icon: { type: 'dashboard' },
    path: '/dashboard',
    highlighted: '/dashboard',
    exact: true,
    component: Landing,
    sideRoutes: SideRoutes,
    restrictRoles: [2],
  },
  orders: {
    title: 'Outgoing Orders',
    icon: { type: 'menu-unfold' },
    path: '/dashboard/orders',
    highlighted: '/dashboard/orders',
    component: Orders,
    sideRoutes: SideRoutes,
  },
  incomingorders: {
    title: 'Incoming Orders',
    icon: { type: 'menu-fold' },
    path: '/dashboard/incomingorders',
    highlighted: '/dashboard/incomingorders',
    component: Orders,
    sideRoutes: SideRoutes,
  },
  placedorders: {
    title: 'Placed Orders',
    icon: { type: 'menu-fold' },
    path: '/dashboard/placedorders',
    highlighted: '/dashboard/placedorders',
    component: Orders,
    sideRoutes: SideRoutes,
  },
  adminOrders: {
    title: 'Orders',
    icon: { type: 'unordered-list' },
    path: '/dashboard/adminManageOrders',
    highlighted: '/dashboard/adminManageOrders',
    component: Orders,
    sideRoutes: AdminSideRoutes,
  },
  adminEditOrder: {
    title: 'Edit Order',
    icon: { type: 'plus' },
    path: '/dashboard/adminEditOrder',
    highlighted: '/dashboard/adminManageOrders',
    component: Order,
    sideRoutes: AdminSideRoutes,
  },
  adminRoutes: {
    title: 'Routes',
    icon: { type: 'ordered-list' },
    path: '/dashboard/manageRoutes',
    highlighted: '/dashboard/manageRoutes',
    component: RoutesComponent,
    sideRoutes: AdminSideRoutes,
  },
  adminEditRoute: {
    title: 'Edit Route',
    icon: { type: 'plus' },
    path: '/dashboard/editRoute',
    highlighted: '/dashboard/manageRoutes',
    component: Route,
    sideRoutes: AdminSideRoutes,
  },
  manageSchedule: {
    title: 'Schedule',
    icon: { type: 'calendar-alt' },
    path: '/dashboard/manageSchedule',
    highlighted: '/dashboard/manageSchedule',
    component: Schedule,
    sideRoutes: SideRoutes,
  },
  adminSchedule: {
    title: 'Schedule',
    icon: { type: 'calendar-alt' },
    path: '/dashboard/adminSchedule',
    highlighted: '/dashboard/adminSchedule',
    component: Schedule,
    sideRoutes: AdminSideRoutes,
  },
  schedule: {
    title: 'Schedule',
    icon: { type: 'calendar-alt' },
    path: '/dashboard/schedule',
    highlighted: '/dashboard/schedule',
    component: Schedule,
    sideRoutes: SideRoutes,
  },
  adminDriver: {
    title: 'Driver Schedule',
    icon: { type: 'car' },
    path: '/dashboard/manageDriver',
    highlighted: '/dashboard/manageDriver',
    component: DriveSchedule,
    public: true,
    showOnLanding: false,
    // Drivers reach this via the user sidebar; admins via the admin sidebar.
    // Pick whichever set matches the role so neither side ends up empty.
    sideRoutes: sState => userHasRole(2, sState) ? SideRoutes : AdminSideRoutes,
  },
  adminBilling: {
    title: 'Billing',
    icon: { type: 'money-check-alt' },
    path: '/dashboard/manageBilling',
    highlighted: '/dashboard/manageBilling',
    component: Reconciliation,
    sideRoutes: AdminSideRoutes,
  },
  operationsLog: {
    title: 'Operations Log',
    icon: { type: 'profile' },
    path: '/dashboard/operationslog',
    highlighted: '/dashboard/operationslog',
    component: OperationsLog,
    sideRoutes: AdminSideRoutes,
    restrictRoles: [2],
  },
  blackoutDates: {
    // Kept in sync with the AdminSideRoutes entry above — one screen must not
    // carry two names. This copy feeds the header/ellipsis menus.
    title: 'Blackout Dates',
    icon: { type: 'calendar' },
    path: '/dashboard/blackoutdates',
    highlighted: '/dashboard/blackoutdates',
    component: BlackoutDates,
    sideRoutes: AdminSideRoutes,
    allowedRoles: [0, 1],
  },
  editOrder: {
    title: 'Edit Order',
    icon: { type: 'plus' },
    path: '/dashboard/editOrder',
    highlighted: '/dashboard/orders',
    component: Order,
    sideRoutes: SideRoutes,
  },
  order: {
    title: 'Create Order',
    icon: { type: 'plus' },
    path: '/dashboard/createOrder',
    highlighted: '/dashboard/createOrder',
    component: Order,
    sideRoutes: SideRoutes,
  },
  orderAdmin: {
    title: 'Create Order',
    icon: { type: 'plus' },
    path: '/dashboard/createAdminOrder',
    highlighted: '/dashboard/createAdminOrder',
    component: Order,
    sideRoutes: AdminSideRoutes,
  },
  admin: {
    title: 'Admin',
    icon: { type: 'user' },
    path: '/dashboard/admin',
    highlighted: '/dashboard/admin',
    component: AdminDashboard,
    sideRoutes: AdminSideRoutes,
    allowedRoles: [0, 1],
    // Clicking this header tab navigates to the configurable admin landing
    // (admin.landingPath) rather than always the Admin Dashboard. See changeRoute.
    isAdminTab: true
  },
  editAccount: {
    title: 'Edit Account',
    icon: { type: 'user' },
    path: '/dashboard/editAccount',
    highlighted: '/dashboard/accounts',
    component: Profile,
    sideRoutes: AdminSideRoutes,
  },
  changeEmail: {
    title: 'Change Email',
    icon: { type: 'lock' },
    path: '/dashboard/changeEmail',
    highlighted: '/dashboard/accounts',
    component: ChangeEmail,
    sideRoutes: SideRoutes,
  },
  changePassword: {
    title: 'Change Password',
    icon: { type: 'lock' },
    path: '/dashboard/changePassword',
    highlighted: '/dashboard/changepassword',
    component: ChangePassword,
    sideRoutes: SideRoutes,
  },
  reconciliation: {
    title: 'Billing',
    icon: { type: 'profile' },
    path: '/dashboard/billing',
    highlighted: '/dashboard/billing',
    component: Reconciliation,
    sideRoutes: AdminSideRoutes,
  },
  reconListAdmin: {
    title: 'Reconciliations Admin',
    icon: { type: 'form' },
    path: '/dashboard/reconlistadmin',
    highlighted: '/dashboard/reconlistadmin',
    component: ReconList,
    sideRoutes: AdminSideRoutes,
  },
  reconList: {
    title: 'Reconciliations',
    icon: { type: 'form' },
    path: '/dashboard/reconlist',
    highlighted: '/dashboard/reconlist',
    component: ReconList,
    sideRoutes: SideRoutes,
  },
  reports: {
    title: 'Reports',
    icon: { type: 'table' },
    path: '/dashboard/reports',
    highlighted: '/dashboard/reports',
    component: Reports,
    sideRoutes: AdminSideRoutes,
  },
  userreports: {
    title: 'Reports',
    icon: { type: 'table' },
    path: '/dashboard/userreports',
    highlighted: '/dashboard/userreports',
    component: UserReports,
    sideRoutes: SideRoutes,
  },
  checkin: {
    title: 'Check In',
    icon: { type: 'login' },
    path: '/dashboard/checkin',
    highlighted: '/dashboard/checkin',
    component: Checkin,
    sideRoutes: sState => userHasRole(2, sState) ? SideRoutes : AdminSideRoutes,
  },
  checkout: {
    title: 'Check Out',
    icon: { type: 'login' },
    path: '/dashboard/checkout',
    highlighted: '/dashboard/checkout',
    component: Checkin,
    sideRoutes: SideRoutes,
  },
  manifestdownload: {
    title: 'Download Manifests',
    icon: { type: 'download' },
    path: '/dashboard/manifestdownload',
    highlighted: '/dashboard/manifestdownload',
    component: ManifestDownload,
    sideRoutes: SideRoutes,
  },
  lnupdate: {
    title: 'LN Update',
    icon: { type: 'edit' },
    path: '/dashboard/lnupdate',
    highlighted: '/dashboard/lnupdate',
    component: LNUpdate,
    sideRoutes: AdminSideRoutes,
  },
  fleetmanager: {
    title: 'Fleet Manager',
    icon: { type: 'car' },
    path: '/dashboard/fleetmanager',
    highlighted: '/dashboard/fleetmanager',
    component: FleetManager,
    sideRoutes: sState => userHasRole(2, sState) ? SideRoutes : AdminSideRoutes,
  },
  schedulesearch: {
    title: 'Delivery Schedule',
    landingTitle: 'Click here for delivery schedule',
    icon: { type: 'file-search' },
    path: '/dashboard/schedulesearch',
    highlighted: '/dashboard/schedulesearch',
    component: ScheduleSearch,
    public: true,
    sideRoutes: SideRoutes,
  },
  accountdelete: {
    title: 'Delete Account',
    landingTitle: 'How to delete your account',
    icon: { type: 'user-delete' },
    path: '/dashboard/deleteaccount',
    highlighted: '/dashboard/schedulesearch',
    sideRoutes: SideRoutes,
    component: DeleteAccount,
  },
  editsettings: {
    title: 'Edit Settings',
    icon: { type: 'edit' },
    path: '/dashboard/settings',
    highlighted: '/dashboard/settings',
    sideRoutes: AdminSideRoutes,
    component: EditConfig,
  },
  faq: {
    title: 'FAQ',
    icon: { type: 'question-circle' },
    path: '/dashboard/faq',
    highlighted: '/dashboard/faq',
    component: FAQ,
    public: true,
    sideRoutes: SideRoutes,
  },
  publicorders: {
    title: 'Orders',
    icon: { type: 'unordered-list' },
    path: '/dashboard/publicorders',
    highlighted: '/dashboard/publicorders',
    component: Orders,
    public: true,
    showOnLanding: false,
    logo: {
      logo: require('../assets/img/leaflink-logo.png'),
      width: 110,
      multiplier: 0.25,
    },
  },
};

export const getPublicRoutes = () => {
  return Object.keys(Routes).filter(k => !!get(Routes, [k, 'public'])).map(k => get(Routes, k));
}